<template>

  <v-checkbox class="checkbox_bookmark"
    off-icon="bookmark_border"
    v-model="checkbox"
    on-icon="bookmark" />

</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapMutations } = createNamespacedHelpers('searchEnginePage')

export default {
  name: 'result-checkbox',
  props: ['result'],
  methods: {
    ...mapMutations(['setResultCheckbox'])
  },
  computed: {
    ...mapState(['selectAllCheckbox', 'resultsCheckbox']),
    checkbox: {
      set (value) {
        this.setResultCheckbox([this.result.objectID, value])
      },
      get () {
        return this.resultsCheckbox[this.result.objectID]
      }
    }
  }
}
</script>
<style>
.checkbox_bookmark {
  float: left;
}
.checkbox_bookmark .v-input__control {
  height: 28px;
}
.checkbox_bookmark{
  margin-top: 2px;
  padding-top: 0px;
}
</style>
